import React from "react";
import {
  Document,
  Page,
  Text,
  View,
  StyleSheet,
  PDFDownloadLink,
} from "@react-pdf/renderer";

// PDF Styles
const styles = StyleSheet.create({
  page: {
    flexDirection: "column",
    backgroundColor: "#ffffff",
    padding: 40,
    fontFamily: "Helvetica",
  },
  header: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: 30,
    paddingBottom: 15,
    borderBottom: "2 solid #2563eb",
  },
  title: {
    fontSize: 28,
    fontWeight: "bold",
    color: "#1e40af",
    letterSpacing: 1,
  },
  receiptNumber: {
    fontSize: 14,
    color: "#64748b",
    fontWeight: "bold",
  },
  section: {
    marginBottom: 20,
  },
  row: {
    flexDirection: "row",
    justifyContent: "space-between",
    marginBottom: 10,
    paddingVertical: 3,
  },
  label: {
    fontSize: 13,
    fontWeight: "bold",
    color: "#475569",
    width: "40%",
  },
  value: {
    fontSize: 13,
    color: "#1e293b",
    width: "60%",
    textAlign: "right",
  },
  amountSection: {
    marginVertical: 25,
    padding: 15,
    backgroundColor: "#f0f9ff",
    border: "2 solid #0ea5e9",
    borderRadius: 8,
    textAlign: "center",
  },
  amountLabel: {
    fontSize: 16,
    color: "#0369a1",
    fontWeight: "bold",
    marginBottom: 5,
  },
  amount: {
    fontSize: 24,
    fontWeight: "bold",
    color: "#0c4a6e",
  },
  description: {
    backgroundColor: "#f8fafc",
    padding: 15,
    marginVertical: 15,
    borderLeft: "4 solid #64748b",
  },
  descriptionLabel: {
    fontSize: 12,
    fontWeight: "bold",
    color: "#475569",
    marginBottom: 5,
  },
  descriptionText: {
    fontSize: 11,
    color: "#64748b",
    lineHeight: 1.4,
  },
  signature: {
    marginTop: 50,
    alignItems: "flex-end",
  },
  signatureLine: {
    width: 200,
    borderTop: "1 solid #64748b",
    paddingTop: 8,
    textAlign: "center",
  },
  signatureText: {
    fontSize: 11,
    color: "#64748b",
  },
  footer: {
    position: "absolute",
    bottom: 30,
    left: 40,
    right: 40,
    paddingTop: 15,
    borderTop: "1 solid #e2e8f0",
    textAlign: "center",
  },
  footerText: {
    fontSize: 9,
    color: "#94a3b8",
    marginBottom: 3,
  },
});

// PDF Receipt Component
const MoneyReceiptPDF = ({ data }) => (
  <Document>
    <Page size="A4" style={styles.page}>
      <View style={styles.header}>
        <Text style={styles.title}>MONEY RECEIPT</Text>
        <Text style={styles.receiptNumber}>🔘{data.ORDER_ID}</Text>
      </View>

      <View style={styles.section}>

        <View style={styles.row}>
          <Text style={styles.label}>Booking No :</Text>
          <Text style={styles.value}>{data.BOOKING_NO}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Patient Name:</Text>
          <Text style={styles.value}>
            {data.PT_NAME}
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Department:</Text>
          <Text style={styles.value}>
            {data.ADMISSION_DEPARTMENT}
          </Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Doctor Name:</Text>
          <Text style={styles.value}>
            {data.DOCTOR}
          </Text>
        </View>
          <View style={styles.row}>
          <Text style={styles.label}>Booking Date Time:</Text>
          <Text style={styles.value}>{data.BOOKING_DATETIME}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Receipt No:</Text>
          <Text style={styles.value}>{data.VOUCHER_NO}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Transaction ID :</Text>
          <Text style={styles.value}>{data.TRANSACTION_ID}</Text>
        </View>
      </View>

      <View style={styles.section}>
        <View style={styles.row}>
          <Text style={styles.label}>Payment Mode :</Text>
          <Text style={styles.value}>ONLINE</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Bank Reference No :</Text>
          <Text style={styles.value}>{data.BANK_TRANSACTION_NO}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Transaction Date :</Text>
          <Text style={styles.value}>{data.RESPONSE_DATE_TIME}</Text>
        </View>
        {/* <View style={styles.row}>
          <Text style={styles.label}>Phone:</Text>
          <Text style={styles.value}>{receiptData.phone}</Text>
        </View>
        {receiptData.email && (
          <View style={styles.row}>
            <Text style={styles.label}>Email:</Text>
            <Text style={styles.value}>{receiptData.email}</Text>
          </View>
        )} */}
      </View>
      <View style={styles.amountSection}>
        <Text style={styles.amountLabel}>Amount</Text>
        <Text style={styles.amount}>RS. {data.TRANSACTION_AMOUNT} /-</Text>
      </View>

      <View style={styles.section}>
        <View style={styles.row}>
          <Text style={styles.label}>Payment Method:</Text>
          <Text style={styles.value}>{data.PAYMENT_MODE}</Text>
        </View>
        <View style={styles.row}>
          <Text style={styles.label}>Purpose:</Text>
          <Text style={styles.value}>CNCI ONLINE APPOINTMENTS</Text>
        </View>
      </View>

      <View style={styles.footer}>
        <Text style={styles.footerText}>
          This is a computer-generated receipt and is valid without signature.
        </Text>
        <Text style={styles.footerText}>
          Generated on {new Date().toLocaleString()}
        </Text>
        <Text style={styles.footerText}>Thank you!</Text>
      </View>
    </Page>
  </Document>
);
export default MoneyReceiptPDF;
// Main Component with Download Link
// export default function MoneyReceiptApp() {
//   return (
//     <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
//       <div className="bg-white rounded-lg shadow-lg p-8 max-w-md w-full text-center">
//         <h1 className="text-2xl font-bold text-gray-800 mb-6">
//           Money Receipt PDF
//         </h1>

//         <div className="space-y-4">
//           <p className="text-gray-600">
//             Click the button below to download a professional money receipt PDF.
//           </p>

//           <PDFDownloadLink
//             document={<MoneyReceiptPDF />}
//             fileName={`money_receipt_${sampleReceiptData.receiptNumber}.pdf`}
//             className="inline-block bg-blue-600 text-white px-6 py-3 rounded-lg font-semibold hover:bg-blue-700 transition-colors duration-200"
//           >
//             {({ blob, url, loading, error }) =>
//               loading ? "Generating PDF..." : "Download Receipt PDF"
//             }
//           </PDFDownloadLink>

//           <div className="mt-6 p-4 bg-gray-50 rounded-lg text-left">
//             <h3 className="font-semibold text-gray-700 mb-2">
//               Receipt Details:
//             </h3>
//             <ul className="text-sm text-gray-600 space-y-1">
//               <li>Receipt #: {sampleReceiptData.receiptNumber}</li>
//               <li>Amount: ${sampleReceiptData.amount}</li>
//               <li>From: {sampleReceiptData.receivedFrom}</li>
//               <li>Purpose: {sampleReceiptData.purpose}</li>
//             </ul>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// }
